import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  & .bottom_fit {
    right: -1.25rem;
  }
`;
